import { Shipment, ShipmentFilters } from "@/types/inventory/shipment";

import { requestData } from "@/api/api-config";

export async function searchShipments(
  searchTerm: string,
  itemIds?: string[],
): Promise<Shipment[] | null> {
  return await requestData<Shipment[]>(`inventory/shipments/search`, "get", {
    searchParams: { searchTerm, itemIds },
  });
}

export async function getShipments(
  filters: ShipmentFilters,
): Promise<Shipment[] | null> {
  return await requestData<Shipment[]>(`inventory/shipments/list`, "get", {
    searchParams: filters,
  });
}

export async function getShipment(id: string): Promise<Shipment | null> {
  return await requestData<Shipment>(`inventory/shipments/${id}`);
}

export async function createShipments(
  shipments: Partial<Shipment>[],
): Promise<Shipment[]> {
  const result = await requestData<Shipment[]>(
    "inventory/shipments/create",
    "post",
    { json: shipments },
    false,
  );
  if (!result) throw new Error("Shipment creation returned no data");
  return result;
}

export async function updateShipments(
  shipmentUpdates: Partial<Shipment>[],
): Promise<Shipment[]> {
  const result = await requestData<Shipment[]>(
    "inventory/shipments/update",
    "put",
    { json: shipmentUpdates },
    false,
  );
  if (!result) throw new Error("Shipment update returned no data");
  return result;
}

export async function deleteShipment(id: string): Promise<Shipment | null> {
  return await requestData<Shipment>(`inventory/shipments/${id}`, "delete");
}
